import { type Shift } from "@src/interface";

/**
 * This is duplicated in clipboard-health/src/utils/checkIsShiftRequestingReplacement.ts
 * So any changes made to this, should be reflected there as well.
 *
 * We could extract this to a common package and import it in the different repositories.
 * https://linear.app/clipboardhealth/issue/AMA-369/review-backend-main-helper-logic-and-consider-cbh-core-integration
 */

export function checkIsShiftRequestingReplacement(shift: Shift) {
  return Boolean(shift.agentId) && shift.urgency === 1 && shift.urgentlyBooked !== true;
}
